import { Trans } from '@lingui/react'

import { FormattedDate } from '@twisto/components/atoms/format'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigEmailOpenIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import * as styles from './otp-verification-email-step-headline.styles'

export const OtpVerificationEmailStepHeadline = () => {
  const { flow } = useFlow<'OtpVerificationEmailStep'>()

  const { emailValue, codeExpiresAt } = flow.currentStep

  return (
    <Headline css={styles.headlineSection}>
      <HeadlineIcon>
        <BigEmailOpenIcon color="primary" height="100%" width="100%" />
      </HeadlineIcon>

      <HeadlineTitle>
        <Trans id="flow.otpVerificationEmailStep.title" />
      </HeadlineTitle>

      <HeadlineSubtitle>
        <Trans
          id="flow.otpVerificationEmailStep.subtitle"
          values={{
            emailValue,
            codeExpiresAt: (
              <FormattedDate
                date={codeExpiresAt ?? ''}
                hour="2-digit"
                minute="2-digit"
              />
            ),
          }}
        />
      </HeadlineSubtitle>
    </Headline>
  )
}
